import { useEffect } from "react";

const BASE_TITLE = "Speak AI";

/**
 * Sets the document title on mount and whenever `title` changes.
 * Format: "<title> | Speak AI". Pass an empty string to use just "Speak AI".
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
